import TopNav from "@/components/feature/TopNav";
import Footer from "@/components/feature/Footer";
import HeroSection from "@/pages/home/components/HeroSection";
import StatsStrip from "@/pages/home/components/StatsStrip";
import HotRankSection from "@/pages/home/components/HotRankSection";
import LatestSection from "@/pages/home/components/LatestSection";
import CategorySection from "@/pages/home/components/CategorySection";
import CommunitySection from "@/pages/home/components/CommunitySection";
import JoinCTA from "@/pages/home/components/JoinCTA";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <TopNav />
      <main className="w-full">
        <HeroSection />
        <StatsStrip />
        <HotRankSection />
        <LatestSection />
        <CategorySection />
        <CommunitySection />
        <JoinCTA />
      </main>
      <Footer />
    </div>
  );
}